import React, { Component } from 'react'
import ReactSwipe from 'react-swipe'
import Hotwords from './pages/Hotwords'
import Message from './pages/Messageboard'
import Topic from './pages/Topic'
import Home from './pages/Home'
import right from './assets/right.png'
export default class App extends Component {
  state = {
    show: true,
  }
  endMove = (index) => {
    if (index === 3) this.setState({ show: false })
    else this.setState({ show: true })
  }
  render() {
    return (
      <>
        <ReactSwipe
          swipeOptions={{
            auto: 0,
            continuous: false,
            callback: (index) => this.endMove(index),
          }}
        >
          <div className="carousel-item">
            <Home />
          </div>
          <div className="carousel-item">
            <Topic />
          </div>
          <div className="carousel-item">
            <Hotwords />
          </div>
          <div className="carousel-item">
            <Message />
          </div>
        </ReactSwipe>
        {this.state.show ? (
          <img className="goRight" src={right} alt="向右" />
        ) : (
          ''
        )}
      </>
    )
  }
}
